import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { walletApi } from '@/https/api/wallet'
import type { WalletBalance, WalletTransactionItem, WalletListRequest, WalletListResponse } from '@/https/types/wallet'

export const useWalletStore = defineStore('wallet', () => {
    const balance = ref<WalletBalance | null>(null)
    const transactions = ref<WalletTransactionItem[]>([])
    const pagination = ref({ total: 0, page: 1, size: 20, has_more: false })
    const loading = ref(false)
    const error = ref<string | null>(null)

    const hasBalance = computed(() => !!balance.value)
    const hasTransactions = computed(() => transactions.value.length > 0)

    const loadBalance = async () => {
        try {
            loading.value = true
            balance.value = await walletApi.getWalletOverview()
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : '获取余额失败'
            error.value = message
            throw err
        } finally {
            loading.value = false
        }
    }

    const loadTransactions = async (params?: WalletListRequest) => {
        try {
            loading.value = true
            error.value = null
            const res: WalletListResponse = await walletApi.getMyTransactions(params)
            transactions.value = res.items
            pagination.value = { total: res.total, page: res.page, size: res.size, has_more: res.has_more }
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : '获取流水失败'
            error.value = message
            throw err
        } finally {
            loading.value = false
        }
    }



    return {
        balance,
        transactions,
        pagination,
        loading,
        error,
        hasBalance,
        hasTransactions,
        loadBalance,
        loadTransactions,
    }
})


